import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumNumberingType implements BaseEnumType {
  private static allValues: EnumNumberingType[] = []; // make sure this is top-most
  
  public static none = new EnumNumberingType(0, "None", "enum_numbering_type_none");
  public static orderNumber = new EnumNumberingType(1, "OrderNumber", "enum_numbering_type_order_number");
  public static tradeInvoice = new EnumNumberingType(2, "TradeInvoice", "enum_numbering_type_trade_invoice");
  public static creditNumber = new EnumNumberingType(4, "CreditNumber", "enum_numbering_type_credit_number");
  public static batchNumber = new EnumNumberingType(5, "BatchNumber", "enum_numbering_type_batch_number");
  public static productBatchCode = new EnumNumberingType(6, "ProductBatchCode", "enum_numbering_type_product_batch_code");
  public static assemblyNumber = new EnumNumberingType(7, "AssemblyNumber", "enum_numbering_type_assembly_number");
  public static stockTransfer = new EnumNumberingType(8, "StockTransfer", "enum_numbering_type_stock_transfer");
  public static ullageNumber = new EnumNumberingType(9, "UllageNumber", "enum_numbering_type_ullage_number");
  public static stockTakeNumber = new EnumNumberingType(10, "StockTakeNumber", "enum_numbering_type_stock_take_number");
  public static purchaseOrderNumber = new EnumNumberingType(11, "PurchaseOrderNumber", "enum_numbering_type_purchase_order_number");
  public static palletNumber = new EnumNumberingType(12, "PalletNumber", "enum_numbering_type_pallet_number");
  public static palletBarcode = new EnumNumberingType(13, "PalletBarcode", "enum_numbering_type_pallet_barcode");
  public static ullageBarcode = new EnumNumberingType(14, "UllageBarcode", "enum_numbering_type_ullage_barcode");
  public static stockAdjustmentNumber = new EnumNumberingType(15, "StockAdjustmentNumber", "enum_numbering_type_stock_adjustment_number");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumNumberingType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumNumberingType.none; }
  public isOrderNumber() { return this === EnumNumberingType.orderNumber; }
  public isTradeInvoice() { return this === EnumNumberingType.tradeInvoice; }
  public isCreditNumber() { return this === EnumNumberingType.creditNumber; }
  public isBatchNumber() { return this === EnumNumberingType.batchNumber; }
  public isProductBatchCode() { return this === EnumNumberingType.productBatchCode; }
  public isAssemblyNumber() { return this === EnumNumberingType.assemblyNumber; }
  public isStockTransfer() { return this === EnumNumberingType.stockTransfer; }
  public isUllageNumber() { return this === EnumNumberingType.ullageNumber; }
  public isStockTakeNumber() { return this === EnumNumberingType.stockTakeNumber; }
  public isPurchaseOrderNumber() { return this === EnumNumberingType.purchaseOrderNumber; }
  public isPalletNumber() { return this === EnumNumberingType.palletNumber; }
  public isPalletBarcode() { return this === EnumNumberingType.palletBarcode; }
  public isUllageBarcode() { return this === EnumNumberingType.ullageBarcode; }
  public isStockAdjustmentNumber() { return this === EnumNumberingType.stockAdjustmentNumber; }

  public static getValues(): readonly EnumNumberingType[] {
    return EnumNumberingType.allValues;
  }

  public static getValuesExcept0(): readonly EnumNumberingType[] {
    return EnumNumberingType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumNumberingType {
    const found = EnumNumberingType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumNumberingType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumNumberingType): EnumNumberingType {
    const found = name ? EnumNumberingType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumNumberingType - Value not found: ${ name }`);
    }

    return found;
  }
}